import enStatusBar from "./en";
import frStatusBar from "./fr";
import deStatusBar from "./de";

export { enStatusBar, frStatusBar, deStatusBar };
